export function initReferences() {
    const section = document.getElementById("references-workforce");
    if (!section) return;

    // Activate JS mode
    section.classList.add("js-on");

    const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (prefersReduced) {
        section.classList.add("is-visible");
        return;
    }

    const text = section.querySelector(".reveal-item.is-text");
    const logos = Array.from(section.querySelectorAll(".reveal-item.is-logo"));
    const STEP = 0.1; // slower stagger for more visible movement

    function setInDelays() {
        if (text) text.style.setProperty("--delay", "0.15s");
        logos.forEach((el, i) => el.style.setProperty("--delay", `${0.25 + i * STEP}s`));
    }

    function setOutDelays() {
        const n = logos.length;
        if (text) text.style.setProperty("--delay", "0s");
        logos.forEach((el, i) => el.style.setProperty("--delay", `${(n - i - 1) * STEP}s`));
    }

    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    setInDelays();
                    section.classList.add("is-visible");
                } else {
                    setOutDelays();
                    section.classList.remove("is-visible");
                }
            });
        },
        { threshold: 0.25 }
    );

    observer.observe(section);
}